<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">
      <div v-for="provider in singleprovider" v-bind:key="provider.id">
        <div class="bg-dark m-b-30">
          <div class="container">
            <div class="row p-b-60 p-t-60">
              <div class="col-md-6 text-center mx-auto text-white p-b-30">
                <div class="m-b-10">
                  <div class="avatar"></div>
                </div>
                <h3 class="h5">{{ provider.agency_name }}</h3>
              </div>
            </div>
          </div>
        </div>
        <section class="pull-up">
          <div class="container">
            <div class="row list">
              <div class="col-lg-12 col-md-12">
                <div class="card m-b-30">
                  <div class="card-header"></div>

                  <div class="card-body">
                    <div class="form-group">
                      <button
                        class="btn btn-outline-primary"
                        @click="acceptProvider"
                        v-if="provider.status == false"
                      >
                        Approve
                      </button>
                      <router-link
                        :to="{ path: '/provider/add-employee/' + provider.id }"
                      >
                        <button class="btn btn-outline-info spacer">
                          Manage Personnel
                        </button>
                      </router-link>

                      <router-link
                        :to="{ path: '/edit-provider/' + provider.id }"
                      >
                        <button
                          class="btn btn-outline-info"
                          style="margin-left: 10px"
                        >
                          Edit Facility
                        </button>
                      </router-link>

                      <button
                        class="btn btn-outline-info mx-2"
                        @click="getAIComments"
                        data-toggle="modal"
                        data-target="#slideRightModalAll"
                      >
                        Reviews
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-3 col-md-3">
                <div class="card m-b-30">
                  <div class="card-body">
                    <div class="pb-2">
                      <router-link :to="{ path: '/view-clients-provider' }">
                        <div class="avatar avatar-lg">
                          <div class="avatar-title bg-soft-info rounded-circle">
                            <i class="mdi mdi-account-group"></i>
                          </div>
                        </div>
                      </router-link>
                    </div>
                    <div>
                      <p class="text-muted text-overline m-0">
                        Total Enrollees
                      </p>
                      <h1 class="fw-400">
                        {{ dashboarddata.enrollees | numeral("0,0") }}
                      </h1>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-3">
                <div class="card m-b-30">
                  <div class="card-body">
                    <div class="pb-2">
                      <div class="avatar avatar-lg">
                        <div class="avatar-title bg-soft-info rounded-circle">
                          <i class="mdi mdi-account-multiple"></i>
                        </div>
                      </div>
                    </div>
                    <div>
                      <p class="text-muted text-overline m-0">Principal</p>
                      <h1 class="fw-400">
                        {{ dashboarddata.principal | numeral("0,0") }}
                      </h1>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-3">
                <div class="card m-b-30">
                  <div class="card-body">
                    <div class="pb-2">
                      <div class="avatar avatar-lg">
                        <div class="avatar-title bg-soft-info rounded-circle">
                          <i class="mdi mdi-account-heart"></i>
                        </div>
                      </div>
                    </div>
                    <div>
                      <p class="text-muted text-overline m-0">Dependents</p>
                      <h1 class="fw-400">
                        {{ dashboarddata.dependants | numeral("0,0") }}
                      </h1>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-3">
                <div class="card m-b-30">
                  <div class="card-body">
                    <div class="pb-2">
                      <div class="avatar avatar-lg">
                        <div class="avatar-title bg-soft-info rounded-circle">
                          <i class="mdi mdi-folder-multiple"></i>
                        </div>
                      </div>
                    </div>
                    <div>
                      <p class="text-muted text-overline m-0">Encounters</p>
                      <h1 class="fw-400">
                        {{ dashboarddata.encounters | numeral("0,0") }}
                      </h1>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-3">
                <div class="card m-b-30">
                  <div class="card-body">
                    <div class="pb-2">
                      <router-link :to="{ path: '/all-claims' }">
                        <div class="avatar avatar-lg">
                          <div class="avatar-title bg-soft-info rounded-circle">
                            <i class="fe fe-credit-card"></i>
                          </div>
                        </div>
                      </router-link>
                    </div>
                    <div>
                      <p class="text-muted text-overline m-0">Claims</p>
                      <h1 class="fw-400">
                        {{ dashboarddata.claims | numeral("0,0") }}
                      </h1>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-3">
                <div class="card m-b-30">
                  <div class="card-body">
                    <div class="pb-2">
                      <div class="avatar avatar-lg">
                        <div class="avatar-title bg-soft-info rounded-circle">
                          <i class="mdi mdi-bank-transfer-out"></i>
                        </div>
                      </div>
                    </div>
                    <div>
                      <p class="text-muted text-overline m-0">
                        Out-going Referrals
                      </p>
                      <h1 class="fw-400">
                        {{ dashboarddata.outgoing_referrals | numeral("0,0") }}
                      </h1>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-3">
                <div class="card m-b-30">
                  <div class="card-body">
                    <div class="pb-2">
                      <div class="avatar avatar-lg">
                        <div class="avatar-title bg-soft-info rounded-circle">
                          <i class="mdi mdi-bank-transfer-in"></i>
                        </div>
                      </div>
                    </div>
                    <div>
                      <p class="text-muted text-overline m-0">
                        In-coming Referrals
                      </p>
                      <h1 class="fw-400">
                        {{ dashboarddata.incoming_referrals | numeral("0,0") }}
                      </h1>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-3">
                <div class="card m-b-30">
                  <div class="card-body">
                    <div class="pb-2">
                      <div class="avatar avatar-lg">
                        <div class="avatar-title bg-soft-info rounded-circle">
                          <i class="mdi mdi-account-tie"></i>
                        </div>
                      </div>
                    </div>
                    <div>
                      <p class="text-muted text-overline m-0">Employees</p>
                      <h1 class="fw-400">
                        {{ dashboarddata.employees | numeral("0,0") }}
                      </h1>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-3">
                <div class="card m-b-30">
                  <div class="card-body">
                    <div class="pb-2">
                      <div class="avatar avatar-lg">
                        <div class="avatar-title bg-soft-info rounded-circle">
                          <i class="mdi mdi-folder-multiple"></i>
                        </div>
                      </div>
                    </div>
                    <div>
                      <p class="text-muted text-overline m-0">
                        Total Utilization Rate
                      </p>
                      <h1 class="fw-400">
                        {{
                          dashboarddata.encounter_rate_total
                            | numeral("0,0.00")
                        }}%
                      </h1>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-3">
                <div class="card m-b-30">
                  <div class="card-body">
                    <div class="pb-2">
                      <div class="avatar avatar-lg">
                        <div class="avatar-title bg-soft-info rounded-circle">
                          <i class="mdi mdi-bank-transfer-out"></i>
                        </div>
                      </div>
                    </div>
                    <div>
                      <p class="text-muted text-overline m-0">
                        Total Referral Rate
                      </p>
                      <h1 class="fw-400">
                        {{
                          dashboarddata.referral_rate_total | numeral("0,0.00")
                        }}%
                      </h1>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-3">
                <div class="card m-b-30">
                  <div class="card-body">
                    <div class="pb-2">
                      <div class="avatar avatar-lg">
                        <div class="avatar-title bg-soft-info rounded-circle">
                          <i class="mdi mdi-folder-multiple"></i>
                        </div>
                      </div>
                    </div>
                    <div>
                      <p class="text-muted text-overline m-0">
                        Utilization Rate (Current Month)
                      </p>
                      <h1 class="fw-400">
                        {{
                          dashboarddata.encounter_rate_current_month
                            | numeral("0,0.00")
                        }}%
                      </h1>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-3">
                <div class="card m-b-30">
                  <div class="card-body">
                    <div class="pb-2">
                      <div class="avatar avatar-lg">
                        <div class="avatar-title bg-soft-info rounded-circle">
                          <i class="mdi mdi-bank-transfer-out"></i>
                        </div>
                      </div>
                    </div>
                    <div>
                      <p class="text-muted text-overline m-0">
                        Referral Rate (Current Month)
                      </p>
                      <h1 class="fw-400">
                        {{
                          dashboarddata.referral_rate_current_month
                            | numeral("0,0.00")
                        }}%
                      </h1>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-3">
                <div class="card m-b-30">
                  <div class="card-body">
                    <div class="pb-2">
                      <div class="avatar avatar-lg">
                        <div class="avatar-title bg-soft-info rounded-circle">
                          <i class="mdi mdi-bank-transfer-out"></i>
                        </div>
                      </div>
                    </div>
                    <div>
                      <p class="text-muted text-overline m-0">
                        Toal Claim Payment (All Time)
                      </p>
                      <h1 class="fw-400">
                        <i class="mdi mdi-currency-ngn"></i>
                        {{ 0 | numeral("0,0.00") }}
                      </h1>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-3">
                <div class="card m-b-30">
                  <div class="card-body">
                    <div class="pb-2">
                      <div class="avatar avatar-lg">
                        <div class="avatar-title bg-soft-info rounded-circle">
                          <i class="mdi mdi-currency-ngn"></i>
                        </div>
                      </div>
                    </div>
                    <div>
                      <p class="text-muted text-overline m-0">
                        Total Enrollee Utilization
                      </p>
                      <h1 class="fw-400">
                        <i class="mdi mdi-currency-ngn"></i
                        >{{ 0 | numeral("0,0.00") }}
                      </h1>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-3">
                <div class="card m-b-30">
                  <div class="card-body">
                    <div class="pb-2">
                      <div class="avatar avatar-lg">
                        <div class="avatar-title bg-soft-info rounded-circle">
                          <i class="fe fe-message-circle"></i>
                        </div>
                      </div>
                    </div>
                    <div>
                      <p class="text-muted text-overline m-0">Reviews</p>
                      <h1 class="fw-400">
                        {{ dashboarddata.reviews | numeral("0,0") }}
                      </h1>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-3">
                <div class="card m-b-30">
                  <div class="card-body">
                    <div class="pb-2">
                      <div class="avatar avatar-lg">
                        <div class="avatar-title bg-soft-info rounded-circle">
                          <i class="mdi mdi-poll"></i>
                        </div>
                      </div>
                    </div>
                    <div>
                      <p class="text-muted text-overline m-0">Avr. Rating</p>
                      <h1 class="fw-400">
                        {{ dashboarddata.average_rating | numeral("0.00") }}
                      </h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-8 col-md-8">
                <div class="card m-b-30">
                  <div class="card-header">
                    <h4 class="h4">Facility Enrollees</h4>
                  </div>

                  <div class="card-body">
                    <div class="table-responsive">
                      <table class="table align-td-middle table-card">
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>OHIS ID</th>
                            <th>Contact</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="enrollee in providerclients"
                            v-bind:key="enrollee.id"
                          >
                            <td>
                              <router-link
                                :to="{ path: '/client/' + enrollee.id }"
                              >
                                {{ enrollee.firstname }} {{ enrollee.lastname }}
                              </router-link>
                            </td>
                            <td>{{ enrollee.id_card_number }}</td>
                            <td>{{ enrollee.phone_number }}</td>
                            <td>{{ enrollee.sector }}</td>

                            <td>
                              <router-link
                                :to="{ path: '/client/' + enrollee.id }"
                              >
                                <button
                                  type="button"
                                  name="button"
                                  class="btn btn-outline-info"
                                >
                                  <i class="fe fe-eye"></i>
                                </button>
                              </router-link>

                              <!-- <button class="btn btn-dark" @click="editUser(enrollee)">change</button> -->
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 col-md-4">
                <div class="card m-b-30">
                  <div class="card-header">
                    <strong class="h4">Facility Details</strong>
                  </div>

                  <div class="card-body">
                    <p>
                      <span v-if="provider.status == true">
                        <button
                          type="button"
                          class="btn m-b-15 ml-2 mr-2 badge badge-soft-success"
                        >
                          approved
                        </button>
                      </span>
                      <span v-if="provider.status == false">
                        <button
                          type="button"
                          class="btn m-b-15 ml-2 mr-2 badge badge-soft-warning"
                        >
                          pending
                        </button>
                      </span>
                    </p>
                    <p>
                      <strong>Beneficiaries Enrolled:</strong>
                      {{ providerclients.length }}
                    </p>
                    <br />
                    <p>
                      <strong>Contact Name:</strong> {{ provider.firstname }}
                      {{ provider.lastname }}
                    </p>
                    <br />
                    <p><strong>E - Mail:</strong> {{ provider.email }}</p>
                    <br />
                    <p>
                      <strong>Phone Number:</strong> {{ provider.phone_number }}
                    </p>
                    <br />
                    <p>
                      <strong>Facilty Type:</strong> {{ provider.phc_general }}
                    </p>
                    <br />
                    <p><strong>Website:</strong> {{ provider.website }}</p>
                    <br />
                  </div>
                </div>
              </div>
            </div>

            <!-- Modal -->
            <div
              class="modal fade modal-slide-right"
              id="slideRightModalAll"
              tabindex="-1"
              role="dialog"
              aria-labelledby="slideRightModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog" role="document">
                <div class="modal-content" id="printDiv" ref="printNow">
                  <div class="modal-header">
                    <p class="modal-title" id="slideRightModalLabel">
                      <span class="h5">Comments</span>
                    </p>

                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>

                  <div class="modal-body">
                    <div class="col-md-12 my-2">
                      <p class="h5">Summary</p>
                      <p>
                        {{ summary }}
                      </p>
                    </div>
                    <div class="container">
                      <div class="row">
                        <div class="col-md-12 m-b-30">
                          <div class="card">
                            <div class="card-header border-bottom">
                              <div
                                class="row text-muted no-gutters align-items-center"
                              >
                                <div class="col">Reviews</div>
                                <div class="col-4 d-none d-md-block text-muted">
                                  <div
                                    class="row no-gutters align-items-center"
                                  >
                                    <div class="col-4">Rating</div>
                                    <!-- <div class="col-8">User</div> -->
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="container-fluid">
                              <!--single-thread-->
                              <div
                                class="row p-t-10 p-b-10 align-items-center border-bottom"
                                v-for="comment in comments"
                                :key="comment"
                              >
                                <div class="col">
                                  <a href="#" class="text-big">
                                    {{ comment.body }}
                                  </a>
                                  <div class="my-1">
                                    <button
                                      class="btn m-b-15 badge badge-soft-info btn-sm"
                                      v-if="comment.sentiment == 'Neutral'"
                                    >
                                      {{ comment.sentiment }}
                                    </button>

                                    <button
                                      class="btn m-b-15 badge badge-soft-success btn-sm"
                                      v-if="comment.sentiment == 'Positive'"
                                    >
                                      {{ comment.sentiment }}
                                    </button>

                                    <button
                                      class="btn m-b-15 badge badge-soft-danger btn-sm"
                                      v-if="comment.sentiment == 'Negative'"
                                    >
                                      {{ comment.sentiment }}
                                    </button>

                                    <a
                                      class="btn m-b-15 badge badge-soft-dark btn-sm mx-1"
                                      role="button"
                                      target="_blank"
                                      :href="`/encounter/${comment.health_record.id}`"
                                    >
                                      <i class="mdi mdi-medical-bag"></i>
                                    </a>
                                  </div>
                                  <div class="text-muted small mt-1">
                                    {{
                                      comment.created_at | moment("from", "now")
                                    }}
                                    &nbsp;·&nbsp;
                                    <a href="#" class="text-muted">
                                      {{ comment.user.firstname }}
                                      {{ comment.user.lastname }}
                                    </a>
                                  </div>
                                </div>
                                <div class="d-none d-md-block col-4">
                                  <div
                                    class="row no-gutters align-items-center"
                                  >
                                    <div class="col-4"
                                    v-if="comment.health_record != null"
                                    >
                                      <star-rating
                                        star-size="15"
                                        :rating="comment.health_record.rating.score"
                                        :show-rating="false"
                                        read-only="true"
                                        active-color="#198754"
                                      ></star-rating>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!--end single-thread-->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      data-dismiss="modal"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!--End of Modal -->
          </div>

          <div class="vld-parent">
            <loading
              :active.sync="isLoading"
              loader="dots"
              :can-cancel="true"
              :is-full-page="fullPage"
            ></loading>
          </div>
        </section>
      </div>
    </main>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin
import StarRating from "vue-star-rating";

export default {
  components: {
    Navbar,
    Loading,
    StarRating,
  },
  data() {
    return {
      user: null,
      comments: "",
      singleprovider: "",
      providerclients: "",
      summary: "",
      dashboarddata: "",
      edit: false,
      isLoading: false,
      fullPage: true,
      agency_id: "",
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.axios
      .get(`/api/v1/auth/detailedProviderHmo/${this.$route.params.id}`)
      .then((response) => {
        this.singleprovider = response.data.data;
        console.log(response);
      })
      .catch((error) => {
        console.error(error);
      });
  },
  methods: {
    dynamicClass() {
      return {
        active: this.isActive,
        disabled: this.isDisabled,
        highlighted: this.isHighlighted,
      };
    },
    getData() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/provider-dashboard-data/${this.$route.params.id}`)
        .then((response) => {
          this.dashboarddata = response.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getProvider() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/detailedProviderHmo/${this.$route.params.id}`)
        .then((response) => {
          this.singleprovider = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    getProviderClients() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/getProviderToUser/${this.$route.params.id}`)
        .then((response) => {
          this.providerclients = response.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    getComments() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/comments`, {
          params: {
            paginate_value: 30,
            provider_id: this.$route.params.id,
          },
        })
        .then((response) => {
          this.comments = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    getAIComments() {
      this.axios
        .post(`https://api-aicomments.hayokmedicare.ng/analyze_sentiments`, {
          comments: this.comments,
        })
        .then((response) => {
          this.comments = response.data.comments;
          this.summary = response.data.summary;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    acceptProvider() {
      if (confirm("Are You Sure You Want to Approve Provider?")) {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.isLoading = true;
        this.axios
          .post("/api/v1/auth/approveDisapproveProviderByAgency", {
            agency_id: 95930,
            provider_id: this.$route.params.id,
            status: 1,
          })
          .then((response) => {
            console.log(response);
            this.$breadstick.notify("Provider Approved!", {
              position: "top-right",
            });
            this.isLoading = false;
            this.getProvider();
            this.$router.push(`/my-providers`);
          })
          .catch((error) => {
            console.log(error.response);
            this.isLoading = false;
          });
      }
    },
    rejectProvider() {
      if (confirm("Are You Sure You Want to Disapprove this Provider?")) {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.isLoading = true;
        this.axios
          .post("/api/v1/auth/approveDisapproveProviderByAgency", {
            agency_id: this.user.id,
            provider_id: this.$route.params.id,
            status: 0,
          })
          .then((response) => {
            console.log(response);
            this.$breadstick.notify("Provider Disapproved!", {
              position: "top-right",
            });
            this.isLoading = false;
            this.getProvider();
          })
          .catch((error) => {
            console.log(error.response);
            this.isLoading = false;
          });
      }
    },
    clearIt() {
      this.agency_id = "";
    },
    editUser(enrollee) {
      this.isLoading = true;
      this.axios
        .patch(`/api/v1/auth/id-card-number/change/${enrollee.id}`)
        .then((response) => {
          console.log(response);
          // this.getClients()
          this.$toasted.success("Changed Successfully", {
            position: "top-center",
            duration: 3000,
          });
          this.isLoading = false;
        })
        .catch((error) => {
          console.error(error);
          this.$toasted.error("Error!", {
            position: "top-center",
            duration: 3000,
          });
          this.isLoading = false;
        });
    },
  },
  created() {
    this.getProvider();
    this.getProviderClients();
    this.getData();
    this.getComments();
  },
};
</script>
<style>
.spacer {
  margin-left: 15px;
}
.Neutral {
  @apply btn m-b-15 badge badge-soft-info;
}
.Positive {
  @apply btn m-b-15 badge badge-soft-success;
}
.Negative {
  @apply btn m-b-15 badge badge-soft-danger;
}
</style>
